<template>
  <div class="cmp cmp-card">
    <div class="card-header" v-show="showHeader">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <slot name="body"></slot>
    </div>
    <div class="card-footer" v-show="showFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "cmp-card",
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.cmp-card {
  margin-bottom: 20px;
  // border-radius: 20px;
  background-image: linear-gradient(#ecf5fb, 80%, #ffffff);
  .card-header {
    min-height: 68px;
    padding: 14px 18px;
    font-size: 20px;
    font-weight: 600;
    line-height: 40px;
    color: #464c5b;
    border-bottom: 1px solid #dde2e6;
    position: relative;
  }
  .card-body {
    padding: 18px;
  }
  .card-footer {
    height: 60px;
    padding: 14px 18px;
    // background-color: #e8e8e8;
    color: #9ea7b4;
    line-height: 40px;
  }
}
</style>
